import { render, staticRenderFns } from "./IconBonusPaymentMethod.vue?vue&type=template&id=c95fba80"
import script from "./IconBonusPaymentMethod.vue?vue&type=script&lang=js"
export * from "./IconBonusPaymentMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports